const API = process.env.REACT_APP_BACKEND_URL;

export function learnerId() {
  let id = "";
  try {
    id = localStorage.getItem("stoicos.logic.learner") || "";
    if (!id) {
      id = (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(36).slice(2));
      localStorage.setItem("stoicos.logic.learner", id);
    }
  } catch { id = "anonymous-learner"; }
  return id;
}

export async function fetchCourse() {
  const r = await fetch(`${API}/api/academy/logic/course`, { headers: adminAuthHeaders() });
  if (!r.ok) throw new Error("course failed");
  return r.json();
}

// Founder/admin browsing the public site keeps full lesson access via the
// existing admin token (read by the backend's access resolver).
export function adminAuthHeaders() {
  try {
    const t = localStorage.getItem("stoicos.admin.token");
    return t ? { Authorization: `Bearer ${t}` } : {};
  } catch { return {}; }
}

export async function fetchProgress() {
  const r = await fetch(`${API}/api/academy/logic/progress/${learnerId()}`);
  if (!r.ok) return { records: [] };
  return r.json();
}

export async function saveProgress(payload) {
  const r = await fetch(`${API}/api/academy/logic/progress/${learnerId()}`, {
    method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload),
  });
  return r.ok;
}

export async function deleteLessonWork(lessonSlug) {
  const r = await fetch(`${API}/api/academy/logic/progress/${learnerId()}/${lessonSlug}`, { method: "DELETE" });
  return r.ok;
}

export async function resetProgress() {
  const r = await fetch(`${API}/api/academy/logic/progress/${learnerId()}`, { method: "DELETE" });
  return r.ok;
}

export const loc = (v, lang = "en") => (v && typeof v === "object" ? v[lang] || v.en || "" : v || "");

/* ---------------- Phase B/C additions ---------------- */

async function get(path) {
  const r = await fetch(`${API}/api/academy/logic${path}`);
  if (!r.ok) throw new Error(`GET ${path} failed`);
  return r.json();
}

async function send(method, path, body) {
  const r = await fetch(`${API}/api/academy/logic${path}`, {
    method, headers: { "Content-Type": "application/json" },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!r.ok) {
    const t = await r.json().catch(() => ({}));
    const err = new Error(typeof t.detail === "string" ? t.detail : "Request failed");
    err.detail = t.detail;
    throw err;
  }
  return r.json();
}

let _termsCache = null;
export function fetchTerms() {
  if (!_termsCache) _termsCache = get("/terms").then((d) => d.terms || []);
  return _termsCache;
}

let _interventionsCache = null;
export function fetchInterventions() {
  if (!_interventionsCache) _interventionsCache = get("/interventions").then((d) => d.interventions || {});
  return _interventionsCache;
}

export const fetchAbilities = () => get("/abilities");
export const fetchPracticeProgram = () => get("/practice-program");

export const fetchRecords = () => get(`/records/${learnerId()}`);
export const createRecord = (payload) => send("POST", `/records/${learnerId()}`, payload);
export const updateRecord = (id, payload) => send("PATCH", `/records/${learnerId()}/${id}`, payload);
export const deleteRecord = (id) => send("DELETE", `/records/${learnerId()}/${id}`);

export const fetchPracticeLog = () => get(`/practice-log/${learnerId()}`);
export const addPracticeLog = (practiceId, note) => send("POST", `/practice-log/${learnerId()}`, { practiceId, note });
export const addPattern = (text) => send("POST", `/patterns/${learnerId()}`, { text });
export const deletePattern = (id) => send("DELETE", `/patterns/${learnerId()}/${id}`);

export const fetchAbilityEvidence = () => get(`/ability-evidence/${learnerId()}`);
export const submitAbilityEvidence = (abilityId, evidence) => send("POST", `/ability-evidence/${learnerId()}`, { abilityId, evidence });

export const fetchChamber = () => get("/chamber");
export const fetchChamberSession = () => get(`/chamber/session/${learnerId()}`);
export const saveChamberStage = (stageId, responses) => send("POST", `/chamber/session/${learnerId()}`, { stageId, responses });
export const submitChamber = () => send("POST", `/chamber/submit/${learnerId()}`);
